import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "../Admin/Dashboard";
import Clients from "../Admin/Clients";
import Accounts from "../Admin/Accounts";
import Retainers from "../Admin/Retainers";
import ClientInfo from "../Pages/ClientInfo";
import RetainerInfo from "../Pages/RetainerInfo";
import EditAccount from "../Handle_Accounts/EditAccount";
import Login from "./Login";
import ClientPage from "../Pages/ClientPage";
import RetainerPage from "../Pages/RetainerPage";
import Post from "../posts/post";
import ProfileClient from "../Profile/ProfileClient";
import ProfileAdmin from "../Profile/ProfileAdmin";
import ProfileRetainer from "../Profile/ProfileRetainer";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Login/>}></Route>
        <Route path='/dashboard' element={<Dashboard />}></Route>
        <Route path='/clientpage' element={<ClientPage />}></Route>
        <Route path='/retainerpage' element={<RetainerPage />}></Route>
        <Route path='/clients' element={<Clients />}></Route>
        <Route path='/retainers' element={<Retainers />}></Route>
        <Route path='/accounts' element={<Accounts />}></Route>
        <Route path='/profileclient' element={<ProfileClient />}></Route>
        <Route path='/profileretainer' element={<ProfileRetainer />}></Route>
        <Route path='/profileadmin' element={<ProfileAdmin />}></Route>
        <Route path='/retainerinfo/:id' element={<RetainerInfo/>}></Route>
        <Route path='/editaccount/:id' element={<EditAccount/>}></Route>
        <Route path='/clientinfo/:id' element={<ClientInfo />} />
        <Route path='/post' element={<Post />}/>
      </Routes>
    </BrowserRouter>
  )
}

export default App;
